import { render, staticRenderFns } from "./CorporateRegistration.vue?vue&type=template&id=4c5154fe&scoped=true"
import script from "./CorporateRegistration.vue?vue&type=script&lang=js"
export * from "./CorporateRegistration.vue?vue&type=script&lang=js"
import style0 from "./CorporateRegistration.vue?vue&type=style&index=0&id=4c5154fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5154fe",
  null
  
)

export default component.exports